import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { InitiativeWithProgressOutput } from "../../../../generated/graphql";

const PROGRESS_COLOR = "#014ec7";

const PlayButtonSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={PROGRESS_COLOR}
    stroke={PROGRESS_COLOR}
    strokeWidth={5}
    strokeLinejoin="round"
    strokeLinecap="round"
    className={className}
    aria-hidden
  >
    <path d="M8 5v14l11-7L8 5z" />
  </svg>
);

interface InitiativeListItemProps {
  index: number;
  initiativeWithProgress: InitiativeWithProgressOutput;
  packageName?: string;
  onClick?: () => void;
}

export const InitiativeListItem = ({ index, initiativeWithProgress, packageName, onClick }: InitiativeListItemProps) => (
  <div
    onClick={onClick}
    className="min-w-0 overflow-hidden flex items-center space-x-2 pl-2 pr-2 py-2 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
    style={index === 0 ? { backgroundColor: "rgb(235, 239, 251)" } : undefined}
  >
    <div className="w-7 h-7 relative flex items-center justify-center shrink-0">
      <CircularProgressbar
        value={index === 0 ? 100 : initiativeWithProgress.progress || 0}
        strokeWidth={6}
        styles={buildStyles({
          pathColor: PROGRESS_COLOR,
          trailColor: "#e5e7eb",
        })}
      />
      {index === 0 && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <PlayButtonSvg className="h-4 w-4" />
        </div>
      )}
    </div>
    <div className="truncate flex-1 flex items-center gap-2 flex-wrap">
      <span className="truncate">
        {initiativeWithProgress.unit.is_private === 1
          ? initiativeWithProgress.unit.reassigned_display_name
          : initiativeWithProgress.unit.name}
      </span>
      {packageName && (
        <span className="text-xs border border-blue-500 text-blue-500 px-2 py-0.5 rounded-md shrink-0">
          {packageName}
        </span>
      )}
    </div>
  </div>
);
